import { Container } from "typescript-ioc";
import { EndConsumerSelectorComponentFactory } from "./EndConsumerSelectorComponentFactory";

declare global {
    interface IOri {
        endConsumerSelectorComponentFactory?: EndConsumerSelectorComponentFactory;
    }
}

ori.endConsumerSelectorComponentFactory = Container.get(EndConsumerSelectorComponentFactory);
